import React from "react";
import { Box, Image, SimpleGrid, Heading, Text } from "@chakra-ui/react";

export const ProductsMainContainer = () => {
  return (
    <div>
      <SimpleGrid columns={3}>
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/31DgFUBHGHL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Branded Suitcase Trolleys - American Tourister, Safari, Skybags,
            etc.
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/41-3k4ITJmL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 66% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Smartwatches and Watches: Fossil, Titan and more
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            width="90%"
            margin="auto"
            src="https://m.media-amazon.com/images/I/51++OCtS-SL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 72% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Steal Deals
          </Text>
        </Box>
        {/* second row */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/41X1tI7F+AL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 43% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best offers on Nivea, Vaseline and more
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="10%"
            src="https://m.media-amazon.com/images/I/51vn3XejHbL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 83% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Levi's, BIBA, Allen Solly, Van Heusen & more
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/41j4poUYfaL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 75% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Branded Suitcase Sets - American Tourister, Safari, Skybags, etc.
          </Text>
        </Box>
        {/* row 3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/51M2I6lUOBL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 25% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Mamaearth, The Derma Co, & Bblunt
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            width="80%"
            margin="auto"
            src="https://m.media-amazon.com/images/I/91B0zklg61L._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 70% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best of Footwear & Handbags
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            width="95%"
            margin="auto"
            src="https://m.media-amazon.com/images/I/41bHH44x6UL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Made for Amazon - Clothing Bestsellers
          </Text>
        </Box>
        {/* row4 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="40%"
            src="https://m.media-amazon.com/images/I/21lLzFO5G8L._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" color="white" gap="10px" p="4px ">
            <Text bg="red" fontWeight="bold">
              Up to 42% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best offers on Lakme, Maybelline, Sugar and More
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="30%"
            src="https://m.media-amazon.com/images/I/41yinKzfimL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best offers on Dove, Head & Shoulders and More
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/611+itNwOVL._AC_UF226,226_FMjpg_.png"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Winterwear: Allen Solly, Fort Collins & more
          </Text>
        </Box>
        {/* row5 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/41w6FPd8R1L._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Branded Casual Backpacks & Daypacks - American Tourister, Safari,
            etc.
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/51LFgM72epL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Made for Amazon - Shoes & Handbags Bestsellers
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            w="80%"
            m="auto"
            src="https://m.media-amazon.com/images/I/91OOpHXtdvL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            NIKE, ASICS, New Balance and more
          </Text>
        </Box>
        {/* row 5 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            w="80%"
            m="auto"
            src="https://m.media-amazon.com/images/I/41hFAVmtGLL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best offers on Pears, Santoor and more
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/318R975yhZL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Minimalist: Hide Nothing - Honest & Effective Skincare
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            w="80%"
            m="auto"
            src="https://m.media-amazon.com/images/I/A1WnpFLZnGL._AC_UF226,226_FMjpg_.png"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Lavie, Lino Perros & more
          </Text>
        </Box>
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/31DgFUBHGHL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Branded Suitcase Trolleys - American Tourister, Safari, Skybags,
            etc.
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/41-3k4ITJmL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 66% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Smartwatches and Watches: Fossil, Titan and more
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            width="90%"
            margin="auto"
            src="https://m.media-amazon.com/images/I/51++OCtS-SL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 72% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Steal Deals
          </Text>
        </Box>
        {/* second row */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/41X1tI7F+AL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 43% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best offers on Nivea, Vaseline and more
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="10%"
            src="https://m.media-amazon.com/images/I/51vn3XejHbL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 83% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Levi's, BIBA, Allen Solly, Van Heusen & more
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/41j4poUYfaL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 75% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Branded Suitcase Sets - American Tourister, Safari, Skybags, etc.
          </Text>
        </Box>
        {/* row 3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/51M2I6lUOBL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 25% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Mamaearth, The Derma Co, & Bblunt
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            width="80%"
            margin="auto"
            src="https://m.media-amazon.com/images/I/91B0zklg61L._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 70% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best of Footwear & Handbags
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            width="95%"
            margin="auto"
            src="https://m.media-amazon.com/images/I/41bHH44x6UL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Made for Amazon - Clothing Bestsellers
          </Text>
        </Box>
        {/* row4 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="40%"
            src="https://m.media-amazon.com/images/I/21lLzFO5G8L._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" color="white" gap="10px" p="4px ">
            <Text bg="red" fontWeight="bold">
              Up to 42% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best offers on Lakme, Maybelline, Sugar and More
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="30%"
            src="https://m.media-amazon.com/images/I/41yinKzfimL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best offers on Dove, Head & Shoulders and More
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/611+itNwOVL._AC_UF226,226_FMjpg_.png"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Winterwear: Allen Solly, Fort Collins & more
          </Text>
        </Box>
        {/* row5 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/41w6FPd8R1L._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Branded Casual Backpacks & Daypacks - American Tourister, Safari,
            etc.
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/51LFgM72epL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Made for Amazon - Shoes & Handbags Bestsellers
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            w="80%"
            m="auto"
            src="https://m.media-amazon.com/images/I/91OOpHXtdvL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            NIKE, ASICS, New Balance and more
          </Text>
        </Box>
        {/* row 5 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            w="80%"
            m="auto"
            src="https://m.media-amazon.com/images/I/41hFAVmtGLL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best offers on Pears, Santoor and more
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/318R975yhZL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Minimalist: Hide Nothing - Honest & Effective Skincare
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            w="80%"
            m="auto"
            src="https://m.media-amazon.com/images/I/A1WnpFLZnGL._AC_UF226,226_FMjpg_.png"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Lavie, Lino Perros & more
          </Text>
        </Box>{" "}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/31DgFUBHGHL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Branded Suitcase Trolleys - American Tourister, Safari, Skybags,
            etc.
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/41-3k4ITJmL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 66% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Smartwatches and Watches: Fossil, Titan and more
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            width="90%"
            margin="auto"
            src="https://m.media-amazon.com/images/I/51++OCtS-SL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 72% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Steal Deals
          </Text>
        </Box>
        {/* second row */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/41X1tI7F+AL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 43% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best offers on Nivea, Vaseline and more
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="10%"
            src="https://m.media-amazon.com/images/I/51vn3XejHbL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 83% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Levi's, BIBA, Allen Solly, Van Heusen & more
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/41j4poUYfaL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 75% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Branded Suitcase Sets - American Tourister, Safari, Skybags, etc.
          </Text>
        </Box>
        {/* row 3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/51M2I6lUOBL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 25% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Mamaearth, The Derma Co, & Bblunt
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            width="80%"
            margin="auto"
            src="https://m.media-amazon.com/images/I/91B0zklg61L._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 70% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best of Footwear & Handbags
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            width="95%"
            margin="auto"
            src="https://m.media-amazon.com/images/I/41bHH44x6UL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Made for Amazon - Clothing Bestsellers
          </Text>
        </Box>
        {/* row4 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="40%"
            src="https://m.media-amazon.com/images/I/21lLzFO5G8L._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" color="white" gap="10px" p="4px ">
            <Text bg="red" fontWeight="bold">
              Up to 42% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best offers on Lakme, Maybelline, Sugar and More
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="30%"
            src="https://m.media-amazon.com/images/I/41yinKzfimL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best offers on Dove, Head & Shoulders and More
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/611+itNwOVL._AC_UF226,226_FMjpg_.png"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Winterwear: Allen Solly, Fort Collins & more
          </Text>
        </Box>
        {/* row5 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/41w6FPd8R1L._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Branded Casual Backpacks & Daypacks - American Tourister, Safari,
            etc.
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/51LFgM72epL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Made for Amazon - Shoes & Handbags Bestsellers
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            w="80%"
            m="auto"
            src="https://m.media-amazon.com/images/I/91OOpHXtdvL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            NIKE, ASICS, New Balance and more
          </Text>
        </Box>
        {/* row 5 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            w="80%"
            m="auto"
            src="https://m.media-amazon.com/images/I/41hFAVmtGLL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best offers on Pears, Santoor and more
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/318R975yhZL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Minimalist: Hide Nothing - Honest & Effective Skincare
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            w="80%"
            m="auto"
            src="https://m.media-amazon.com/images/I/A1WnpFLZnGL._AC_UF226,226_FMjpg_.png"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Lavie, Lino Perros & more
          </Text>
        </Box>{" "}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/31DgFUBHGHL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Branded Suitcase Trolleys - American Tourister, Safari, Skybags,
            etc.
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/41-3k4ITJmL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 66% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Smartwatches and Watches: Fossil, Titan and more
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            width="90%"
            margin="auto"
            src="https://m.media-amazon.com/images/I/51++OCtS-SL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 72% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Steal Deals
          </Text>
        </Box>
        {/* second row */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/41X1tI7F+AL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 43% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best offers on Nivea, Vaseline and more
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="10%"
            src="https://m.media-amazon.com/images/I/51vn3XejHbL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 83% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Levi's, BIBA, Allen Solly, Van Heusen & more
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/41j4poUYfaL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 75% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Branded Suitcase Sets - American Tourister, Safari, Skybags, etc.
          </Text>
        </Box>
        {/* row 3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/51M2I6lUOBL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 25% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Mamaearth, The Derma Co, & Bblunt
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            width="80%"
            margin="auto"
            src="https://m.media-amazon.com/images/I/91B0zklg61L._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 70% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best of Footwear & Handbags
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            width="95%"
            margin="auto"
            src="https://m.media-amazon.com/images/I/41bHH44x6UL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Made for Amazon - Clothing Bestsellers
          </Text>
        </Box>
        {/* row4 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="40%"
            src="https://m.media-amazon.com/images/I/21lLzFO5G8L._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" color="white" gap="10px" p="4px ">
            <Text bg="red" fontWeight="bold">
              Up to 42% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best offers on Lakme, Maybelline, Sugar and More
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="30%"
            src="https://m.media-amazon.com/images/I/41yinKzfimL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best offers on Dove, Head & Shoulders and More
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/611+itNwOVL._AC_UF226,226_FMjpg_.png"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Winterwear: Allen Solly, Fort Collins & more
          </Text>
        </Box>
        {/* row5 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/41w6FPd8R1L._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Branded Casual Backpacks & Daypacks - American Tourister, Safari,
            etc.
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/51LFgM72epL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Made for Amazon - Shoes & Handbags Bestsellers
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            w="80%"
            m="auto"
            src="https://m.media-amazon.com/images/I/91OOpHXtdvL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            NIKE, ASICS, New Balance and more
          </Text>
        </Box>
        {/* row 5 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            w="80%"
            m="auto"
            src="https://m.media-amazon.com/images/I/41hFAVmtGLL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Best offers on Pears, Santoor and more
          </Text>
        </Box>
        {/* box2 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            marginLeft="20%"
            src="https://m.media-amazon.com/images/I/318R975yhZL._AC_UF226,226_FMjpg_.jpg"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Minimalist: Hide Nothing - Honest & Effective Skincare
          </Text>
        </Box>
        {/* box3 */}
        <Box height="auto" border="1px solid gray" alignItems="center">
          <Image
            w="80%"
            m="auto"
            src="https://m.media-amazon.com/images/I/A1WnpFLZnGL._AC_UF226,226_FMjpg_.png"
          ></Image>
          <Box display="flex" gap="10px" p="4px ">
            <Text bg="red" color="white" fontWeight="bold">
              Up to 73% off
            </Text>
            <Text fontSize="xs" fontWeight="bold" color="red">
              Republic Day Sale
            </Text>
          </Box>
          <Text textAlign="left" fontSize="sm">
            Lavie, Lino Perros & more
          </Text>
        </Box>
      </SimpleGrid>
    </div>
  );
};
